import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "common_component/Navbar";
import Footer from "common_component/Footer";
import { useMaterialUIController, setLayout } from "context";

const UserLayout = () => {
  const [, dispatch] = useMaterialUIController();

  useEffect(() => {
    setLayout(dispatch, "page"); 
  }, [dispatch]);

  return (
    <>
      <Navbar />
      <div style={{ minHeight: "80vh" }}>
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default UserLayout;